// filepath: client/src/AppRouter.jsx
import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import publicRoutes from '#client/routes/publicRoutes';
import protectedRoutes from '#client/routes/protectedRoutes';
import customerRoutes from '#client/routes/customerRoutes';
import TitleLayout from './components/common/TitleLayout/TitleLayout';

const router = createBrowserRouter([
    {
        path: '/',
        element: <TitleLayout />,
        children: [...publicRoutes, ...protectedRoutes, ...customerRoutes],
    },
]);

const AppRouter = () => {
    return <RouterProvider router={router} />;
};

export default AppRouter;
